module.exports = __webpack_public_path__ + "static/img/miniImg2.643f2392.png";